<mat-form-field class="ic-input-multiple-select" [appearance]="appearance">
  <mat-label>{{ inputLabel }}</mat-label>
  <mat-select [formControl]="inputFormControl" multiple>
    <mat-option *ngIf="hasDefaultOption">{{ defaultOptionText }}</mat-option>
    <mat-option *ngFor="let option of options" [value]="option.id">{{
      option.text
    }}</mat-option>
  </mat-select>
</mat-form-field>
